module.exports = __webpack_public_path__ + "static/media/Insure Comp -2 new.98fb6496.png";